import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import {
    Container,
    Section,
    PageHero,
} from "@/components/Primitives";

const BLOCKS = [
    {
        title: "Risk of loss.",
        body: "Day trading, including futures, carries a high level of risk and can result in losses exceeding your initial investment. Only trade with capital you can afford to lose.",
    },
    {
        title: "Not financial advice.",
        body: "The Aegis Line is a software tool that automates a trading process you configure and supervise. Nothing on this site or in the product constitutes investment, legal, or tax advice. We are not a registered broker-dealer or investment adviser.",
    },
    {
        title: "Simulated performance.",
        body: "The Aegis Line currently operates in paper-trading mode. Simulated results do not account for slippage, spread, partial fills, or liquidity constraints. Simulated results are an upper bound and are not indicative of live results.",
    },
    {
        title: "No guarantee of edge.",
        body: "No representation is made that any account will or is likely to achieve profits or losses similar to those discussed.",
    },
    {
        title: "Jurisdiction-specific disclosures.",
        body: "Additional jurisdiction-specific disclosures, CFTC/NFA-style futures language where applicable, and counsel-reviewed final text will be added before any public launch.",
        placeholder: true,
    },
];

export default function RiskDisclosure() {
    return (
        <>
            <Seo
                title="Risk disclosure"
                description="Full risk disclosure for The Aegis Line. Trading stocks and futures involves substantial risk of loss. Simulated results are an upper bound and not indicative of live results."
            />
            <PageHero
                eyebrow="Legal"
                title="Risk disclosure."
                sub="Trading stocks and futures involves substantial risk of loss and is not suitable for everyone. Read this in full."
            />

            <Section>
                <Container className="max-w-3xl">
                    <Reveal>
                        <div className="rounded-lg border border-warn/30 bg-ink-soft p-6 sm:p-8">
                            <p className="font-mono text-xs uppercase tracking-[0.18em] text-warn">
                                Standing notice
                            </p>
                            <p className="mt-3 text-base leading-relaxed text-text-hi">
                                Trading stocks and futures involves substantial
                                risk of loss and is not suitable for everyone.
                                Past or simulated performance does not guarantee
                                future results. The Aegis Line is a software tool, not
                                financial advice.
                            </p>
                        </div>
                    </Reveal>

                    <div className="mt-10 space-y-8">
                        {BLOCKS.map((b, i) => (
                            <Reveal key={b.title} delay={i * 0.05}>
                                <div className="border-l-2 border-haze pl-6">
                                    <h2 className="text-lg font-semibold text-text-hi">
                                        {b.title}
                                    </h2>
                                    <p className="mt-2 text-sm leading-relaxed text-text-lo sm:text-base">
                                        {b.body}
                                    </p>
                                    {b.placeholder && (
                                        <span className="mt-3 inline-flex rounded-sm border border-rule/40 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-rule">
                                            To be finalized by counsel
                                        </span>
                                    )}
                                </div>
                            </Reveal>
                        ))}
                    </div>

                    <Reveal>
                        <p className="mt-12 font-mono text-xs leading-relaxed text-text-lo">
                            This skeleton disclosure is provided for the concept
                            build and must be reviewed and finalized by a
                            qualified professional before any public launch.
                        </p>
                    </Reveal>
                </Container>
            </Section>
        </>
    );
}
